/**
 * @module app.core
 */

import { autoinject, transient } from "aurelia-framework";
import { EnvironmentService } from 'app/shared/services/environment-service';
import { IApiQueryResults, IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { Api } from 'app/shared/lib/api/api';
import * as Core from 'app/core/models/essette-api';


@transient()
@autoinject()
export class NavigationService {

    constructor(protected readonly api: Api, private readonly env: EnvironmentService) { }

    public async loadMenu(): Promise<IApiQueryResults<Core.AccountMenuItem>> {
        // TODO: make account/menu filter by application automatically -mwj (user story TFS-54305)
        const query = this.api
            .query('account/menu')
            .strategy('security')
            //.filterString('application.id', this.env.application.id);
            .filterIdentifier('application.id', this.env.application.id);

        return await this.api.get(query);
    }

    public async loadHomePages(options?: Partial<IQueryLoadOptions>, includes: string[] = []): Promise<IApiQueryResults<Core.NavigationHomePage>> {
        const query = this.api
            .query('navigation/pages/home')
            .filterIdentifier('application.id', this.env.application.id)
            .applyStandardLoadOptions(options)
            .include(...includes);

        return await this.api.get(query);
    }

}
